import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";

import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';

import UniqueDiscountCodeCard from '../components/setting/UniqueDiscountCodeCard';
import GeneralDiscountCodeCard from '../components/setting/GeneralDiscountCodeCard';

const DiscountCode = ({ token, admin }) => {

    const history = useHistory();

    const [toggled, setToggled] = useState(false);

    useEffect(() => {
        if (!admin || !admin.discount_code) {
            history.push('/admin/dashboard')
        }
    }, [])

    const handleToggle = () => {
        setToggled(!toggled);
    }

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={handleToggle} />

            <div className="admin-page">
                <Topbar handleToggle={handleToggle} />

                <div className="admin-content">
                    <GeneralDiscountCodeCard id={admin?.operatorId} role="operator" token={token} country={admin?.country} outlets={admin?.outlets} />
                    <UniqueDiscountCodeCard id={admin?.operatorId} role="operator" token={token} country={admin?.country} outlets={admin?.outlets} />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        admin: state.admin.admin,
        token: state.admin.token
    };
};

export default connect(mapStateToProps, null)(DiscountCode);